/*********************************
 * 
 * @name 单位转换工具
 * @function charToPx 字符转像素
 * @function cmToPx 厘米转像素
 * @function measureFormat 表单尺寸数据格式化
 * @function moneyToCapitals 金钱小写转大写
 * @author liuguisheng
 * @version 2019-11-23
 * 
**********************************/


/**
 * @name 字符转像素
 * @param { Number } length 字符长度
 * @param { fontSize } fontSize 字体大小
 * @author liuguisheng
 * @version 2019-11-23
*/
export const charToPx = function ( length, fontSize ) {
    return length * fontSize + 'px';
}

/**
 * @name 厘米转像素
 * @param { Number } cm 厘米
 * @author liuguisheng
 * @version 2019-11-23 
*/
export const cmToPx = function ( cm ) {
    return Math.floor( cm * 28.346 );
}

/** @name 表单尺寸数据格式化
 *  @description 表单项设置中对没有单位的尺寸值，自动添加px
 *  @param {String} measure 表单项设置中的尺寸
 *  @param {String} 格式化后的尺寸
 *  @author 王汝鹏
 *  @version 2019-09-25
 */
export const measureFormat = function(measure) {
if (/^\d+$/.test(measure)) return `${measure}px`;
return measure;
}

/**
 * @name 金钱小写转大写工具
 * @returns { String } 转换后的结果 
 * @params { Number } n 小写数字
 * @author liuguisheng
 * @version 2019-9-22
*/

export const moneyToCapitals = function( n ) {
    // 小数部分
    let fraction = ['角', '分'];
    // 数字部分
    let digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    // 单位
    let unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    // 是否为负值，if T 前边加 ’欠‘
    let head = n < 0 ? '欠' : '';
    // 取绝对值
    n = Math.abs(n);
    let s = '';
    // 小数计算
    for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    // 单位计算
    for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = '';
        for (let j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
};
  
  


// WEBPACK FOOTER //
// ./src/utils/unit_format.js